// 首屏元素數量計算工具
export function calculateFirstScreenCounts() {
  const width = window.innerWidth;
  
  // 基於實際 CSS grid 配置計算 Post 欄數
  // Tailwind 斷點: 4xl:1920px, 2xl:1536px, lg:1024px, md:780px, smd:705px
  let postCols;
  if (width >= 1920) postCols = 6;      // 4xl:grid-cols-6
  else if (width >= 1536) postCols = 5; // 2xl:grid-cols-5  
  else if (width >= 1024) postCols = 4; // lg:grid-cols-4
  else if (width >= 780) postCols = 3;  // md:grid-cols-3
  else if (width >= 705) postCols = 2;  // smd:grid-cols-2
  else postCols = 1;                    // grid-cols-1
  
  // ProfileCollection 數量計算
  // 基於 ProfileCollection.vue setupItemColsCount 邏輯
  let profileCols;
  if (width >= 1536) profileCols = 8;   // 1536px 以上固定 8 欄
  else if (width >= 780) profileCols = 6;  // 780px-1535px
  else if (width >= 705) profileCols = 5;  // 705px-779px  
  else profileCols = 4;                    // <705px
  
  return {
    // 前兩列的 Post 數量
    firstScreenPostCount: postCols * 2,
    // ProfileCollection 顯示數量  
    firstScreenProfileCount: profileCols,
    // 當前欄數資訊
    postColumns: postCols,
    profileColumns: profileCols
  };
}

export function isFirstScreenPost(index) {
  const { firstScreenPostCount } = calculateFirstScreenCounts();
  return index < firstScreenPostCount;
}

export function isFirstScreenProfile(index) {
  const { firstScreenProfileCount } = calculateFirstScreenCounts();
  return index < firstScreenProfileCount;
}